"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const getComponentsChangeLogUseCase_1 = require("@/useCases/components/getComponentsChangeLogUseCase");
const selectors_1 = require("@/store/ducks/tracking/selectors");
const tracking_1 = require("@/store/ducks/tracking");
const index_view_1 = __importDefault(require("./index.view"));
exports.default = react_1.default.memo(function ComponentsChangeLog() {
    const history = (0, react_router_dom_1.useHistory)();
    const [currentPageIndex, setCurrentPageIndex] = react_1.default.useState(0);
    const dispatch = (0, react_redux_1.useDispatch)();
    const root = document.querySelector("#changelog");
    const loadMoreRef = (0, react_1.useRef)(null);
    const changeLogItems = (0, react_redux_1.useSelector)(selectors_1.changeLogItemsSelector);
    const hasEndingTrackingData = (0, react_redux_1.useSelector)(selectors_1.hasEndingTrackingDataSelector);
    const isLoading = (0, react_redux_1.useSelector)(selectors_1.isTrackingLoadingSelector);
    (0, react_1.useEffect)(() => {
        history.listen(() => {
            dispatch((0, tracking_1.resetChangelogData)());
        });
    }, []);
    (0, react_1.useEffect)(() => {
        const options = {
            root,
            rootMargin: "20px",
            threshold: 0,
        };
        const observer = new IntersectionObserver((entries) => {
            const target = entries[0];
            if (target.isIntersecting) {
                setCurrentPageIndex((prev) => prev + 1);
            }
        }, options);
        if (loadMoreRef && loadMoreRef.current) {
            observer.observe(loadMoreRef.current);
        }
        return () => {
            if (loadMoreRef?.current) {
                observer.unobserve(loadMoreRef?.current);
            }
        };
    }, [changeLogItems]);
    (0, react_1.useEffect)(() => {
        if (!hasEndingTrackingData) {
            (0, getComponentsChangeLogUseCase_1.getComponentsChangeLog)(currentPageIndex, 5)(dispatch);
        }
    }, [currentPageIndex]);
    return (react_1.default.createElement(index_view_1.default, { isLoading: isLoading, changeLogItems: changeLogItems, loadMoreRef: loadMoreRef, hasDataEnded: hasEndingTrackingData }));
});
